import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { consumeHandoffAtBoot } from './lib/handoff';
import './styles.css';

// Helm XR web windows: a #nx_handoff=<ticket> is redeemed before routing and the auth check (lib/handoff.ts).
void consumeHandoffAtBoot().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
});
